<template>
	<ul class="srh__department-toggle flex h-[3.5714285rem] font-medium text-gray-70">
		<ToggleItem department-type="damen">{{ t("siteWide.searchApp.department.women") }}</ToggleItem>
		<ToggleItem department-type="herren">{{ t("siteWide.searchApp.department.men") }}</ToggleItem>
		<ToggleItem department-type="kinder">{{ t("siteWide.searchApp.department.kids") }}</ToggleItem>
	</ul>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
import ToggleItem from "./ToggleItem.vue";

const { t } = useI18n();
</script>

<style>
.srh__department-toggle {
	box-shadow: inset 0 -2px 0 0 var(--color-gray-40);
}
</style>
